import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-single-file-upload',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './single-file-upload.html',
  styleUrl: './single-file-upload.css'
})
export class SingleFileUpload {
  @Input() control!: FormControl;
  @Input() title: string = '';
  @Input() acceptedTypes: string = '.jpg,.png,.pdf,.doc';
  @Input() maxSizeMB: number = 5;

  selectedFile: File | null = null;

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileSizeMB = file.size / (1024 * 1024);

      // Check size
      if (fileSizeMB > this.maxSizeMB) {
        this.control?.setErrors({ maxSizeExceeded: true });
        this.selectedFile = null;
        return;
      }

      // File accepted
      this.selectedFile = file;
      this.control?.setValue(file);
      this.control?.setErrors(null);
    }
  }

  removeFile() {
    this.selectedFile = null;
    this.control?.setValue(null);
    this.control?.setErrors({ required: true });
  }


  triggerFileInput(fileInput: HTMLInputElement) {
    fileInput.click();
  }
}
